import { ErrorMessage, Field, Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';

import RecuperarPassword from "../../components/Modals/RecuperPass";
import MyTextInput from '../../app/common/form/MyTextInput';
import { Button, Header, Label } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';

import { BsEyeSlash } from "@react-icons/all-files/bs/BsEyeSlash";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import loginBack from "../../../src/images/login-back.png"
import RegisterForm from './RegisterForm';
import RecuperarUsuario from '../../components/Modals/RecuperarUsuario';

export default observer(function LoginForm() {
    const [passwordShown, setPasswordShown] = useState(false);

    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    const { userStore, modalStore  } = useStore();
   
    return (


        <Formik
            initialValues={{ email: '', password: '', error: null }}
            onSubmit={(values, { setErrors }) => userStore.login(values).catch(error =>
                setErrors({ error: 'Correo o clave invalidos' }))}
        >

            {({ handleSubmit, isSubmitting, errors, isValid, dirty }) => (

                <>

                    <Container className='login-form-area' id='login-form-area'>
                        <h2>Ingresar</h2>
                        <h3>Accede a la plataforma para asignarte cursos.</h3>
                        <div className='login-back' style={{ backgroundImage: `url(${loginBack})` }}></div>
                        <Row>
                            <Col>

                                <Form className='ui login-form' onSubmit={handleSubmit} autoComplete='off'>

                                    <div className='login-form-content'>
                                        <MyTextInput name='email' placeholder='tunombre@dominio.com' label='Correo electrónico' />
                                        <MyTextInput name='password' id="Password" className='password-input' placeholder='*********' type={passwordShown ? "text" : "password"} label='Contraseña' />
                                        <div className='showpassword-area'>
                                            <a className='showPassword' onClick={togglePassword}> <BsEyeSlash /></a>
                                        </div>
                                        <ErrorMessage
                                            name='error' render={() =>
                                                <Label style={{ marginBottom: 10 }} basic color='red' content={errors.error} />}
                                        />
                                        <div className='btn-area'>
                                            <Button disabled={!isValid || !dirty || isSubmitting} loading={isSubmitting} content='Ingresar' type='submit' />
                                        </div>
                                    </div>
                                    
                                    <div className='modal_registro_btn'>
                                        <p>¿Aún no tienes cuenta?</p>
                                        <a onClick={() => modalStore.openModal(<RegisterForm />, "tiny")}>
                                            Regístrate aquí
                                        </a>
                                    </div>

                                    <div className='recuperar-contraseña'>
                                        <span></span>
                                        <p>¿Olvidaste tu contraseña?</p>
                                        <a onClick={() => modalStore.openModal(<RecuperarPassword correo={""} />, "mini")}>
                                            Recuperar contraseña
                                        </a>
                                    </div>
                                    
                                    <div className='recuperar-contraseña recuperar-usuario'>
                                        <p>¿Olvidaste tu usuario?</p>
                                        <a onClick={() => modalStore.openModal(<RecuperarUsuario padre={'LoginForm'} />, "mini")}>
                                            Recuperar usuario
                                        </a>
                                    </div>

                                </Form>

                            </Col>
                        </Row>
                    </Container>


                </>


            )}

        </Formik>
    )
})